"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _baseService = _interopRequireDefault(require("@/config/base-service"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var MonitorService = /*#__PURE__*/function (_BaseService) {
  _inherits(MonitorService, _BaseService);
  var _super = _createSuper(MonitorService);
  function MonitorService() {
    _classCallCheck(this, MonitorService);
    return _super.call(this, "".concat(process.env.VUE_APP_API_APP_CLIENT, "/monitor"));
  }
  _createClass(MonitorService, [{
    key: "fetchListServices",
    value: function fetchListServices(typeRequest) {
      return this.get("list/".concat(typeRequest));
    }
  }, {
    key: "fetchCountRequestPerType",
    value: function fetchCountRequestPerType(_ref) {
      var typeRequest = _ref.typeRequest,
        service = _ref.service;
      return this.get("services-actives/".concat(typeRequest, "/").concat(service));
    }
  }, {
    key: "fetchLatestCallServiceActiveChartReception",
    value: function fetchLatestCallServiceActiveChartReception(_ref2) {
      var typeRequest = _ref2.typeRequest,
        service = _ref2.service,
        period = _ref2.period;
      var params = _objectSpread({}, period);
      return this.get("services-actives/".concat(typeRequest, "/").concat(service, "/chart"), {
        params: params
      });
    }
  }, {
    key: "fetchServicesLatestRequestPerType",
    value: function fetchServicesLatestRequestPerType(_ref3) {
      var typeRequest = _ref3.typeRequest,
        service = _ref3.service,
        period = _ref3.period;
      var params = _objectSpread({}, period);
      return this.get("services-latest/".concat(typeRequest, "/").concat(service), {
        params: params
      });
    }
  }, {
    key: "fetchServicesSuccessAndErrors",
    value: function fetchServicesSuccessAndErrors(_ref4) {
      var typeRequest = _ref4.typeRequest,
        service = _ref4.service,
        period = _ref4.period;
      var params = _objectSpread({}, period);
      return this.get("services-status/".concat(typeRequest, "/").concat(service), {
        params: params
      });
    }
  }, {
    key: "fetchServicesStatusRequestChart",
    value: function fetchServicesStatusRequestChart(_ref5) {
      var typeRequest = _ref5.typeRequest,
        service = _ref5.service,
        period = _ref5.period;
      var params = _objectSpread({}, period);
      return this.get("services-status-chart/".concat(typeRequest, "/").concat(service), {
        params: params
      });
    }
  }, {
    key: "fetchServiceRequestErrorsList",
    value: function fetchServiceRequestErrorsList(_ref6) {
      var typeRequest = _ref6.typeRequest,
        service = _ref6.service,
        period = _ref6.period;
      var params = _objectSpread({}, period);
      return this.get("services-errors/".concat(typeRequest, "/").concat(service), {
        params: params
      });
    }

    // TODO: Revisar rotas
  }, {
    key: "fetchReception",
    value: function fetchReception(service) {
      return this.get("monitor-service/".concat(service));
    }
  }, {
    key: "fetchLatestServiceCallReception",
    value: function fetchLatestServiceCallReception(period) {
      var params = _objectSpread({}, period);
      return this.get("services-actives/list", {
        params: params
      });
    }
  }, {
    key: "fetchLatestServiceCallChartReception",
    value: function fetchLatestServiceCallChartReception(period) {
      var params = _objectSpread({}, period);
      return this.get("services-actives/chart", {
        params: params
      });
    }
  }]);
  return MonitorService;
}(_baseService.default);
var _default = new MonitorService();
exports.default = _default;